<template>
  <div
    v-for="category in categories"
    :key="category.key"
    class="category-container"
  >
    <FilterCategoryHeader
      v-if="category.show"
      :title="category.name"
      :ats-id="atsId"
      :class-name="category.className"
      :default-icon="category.defaultIcon"
      :tooltip="tooltips[category.tooltipKey] || {}"
    />
    <DpplAccordionPanels
      v-model="selectedPanelId"
      :items="filters[category.key]"
    >
      <template #header="{ item }">
        <div class="panel-title-left">
          <span class="panel-title">{{ item.label }}</span>
          <AppliedFiltersDot
            v-if="originalFilters[item.originalIndex].value.length"
            class="ml-2"
          />
        </div>
        <button
          v-if="originalFilters[item.originalIndex].value.length"
          type="button"
          class="clear-current-filter"
          @click.stop="emit(
            'clearFilters',
            ({ index: item.originalIndex, router: $router }),
          )"
        >
          Clear
        </button>
      </template>
      <template #content="{ item }">
        <FilterExpandedCard
          :field="item"
          @set-to-applied-filters="emit('resetValues', {
            fieldIndex: item.originalIndex,
            setToAppliedFilters: true,
          })"
          @set-temp-filters="emit('setTempFilters', {
            value: $event,
            index: item.originalIndex,
          })"
          @apply-filters="emit('applyFilters')"
          @add-snackbar="emit('addSnackbar', $event)"
        />
      </template>
    </DpplAccordionPanels>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import FilterCategoryHeader from '@/components/filter/FilterCategoryHeader.vue';
import FilterExpandedCard from '@/components/filter/FilterExpandedCard.vue';
import DpplAccordionPanels from '@/components/datapeople/DpplAccordionPanels/DpplAccordionPanels.vue';
import AppliedFiltersDot from '@/components/filter/AppliedFiltersDot.vue';

const props = defineProps({
  categories: {
    type: Array,
    default: () => [],
  },
  filters: {
    type: Object,
    default: () => {},
  },
  originalFilters: {
    type: Array,
    default: () => [],
  },
  atsId: {
    type: Number,
    default: 28,
  },
  tooltips: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits([
  'resetValues', 'setTempFilters', 'applyFilters', 'addSnackbar', 'clearFilters',
]);

const selectedPanelId = ref(null);

const resetSelectedValuesForFilter = (oldVal) => {
  const filterIdx = props.originalFilters.findIndex((filter) => filter.id === oldVal);
  emit('resetValues', {
    fieldIndex: filterIdx,
    setToAppliedFilters: true,
  });
};

watch(selectedPanelId, (newVal, oldVal) => {
  if (newVal !== oldVal && Boolean(oldVal)) {
    resetSelectedValuesForFilter(oldVal);
  }
});
</script>

<style lang="less" scoped>
.category-container {
  display: flex;
  flex-direction: column;

  .filter-category {
    padding-bottom: 16px;
  }
}

.panel-title {
  font-size: 13px;
  font-weight: 500;
  color: @text-light;
  line-height: 150%;
  margin-right: 4px;
  line-height: 150%;
}

.clear-current-filter {
  font-size: 12px;
  font-weight: 500;
  color: @text-brand;
  padding: 0 10px;
  margin-left: auto;
}

.header-title {
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
}
</style>
